<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="12">
              <b-tabs content-class="mt-3">
                <b-tab
                  :title="lang.name"
                  v-for="lang in languages"
                  :key="lang.id"
                >
                  <!-- .question -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-1"
                      :label="$t('faqs.question')"
                      label-for="input-1"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="question"
                        vid="question"
                        rules="required"
                      >
                        <ckeditor
                          :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                          id="input-1"
                          v-model="question[lang.code]"
                        >
                        </ckeditor>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <!-- .answer -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-2"
                      :label="$t('faqs.answer')"
                      label-for="input-2"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="answer"
                        vid="answer"
                        rules="required"
                      >
                        <ckeditor
                          :config="{ contentsLangDirection : 'rtl',versionCheck : false}" 
                          id="input-2"
                          v-model="answer[lang.code]"
                        >
                        </ckeditor>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col></b-tab
                >
              </b-tabs>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/GetFaqsController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import LanguagesController from "@/Controllers/LanguagesController";
export default {
  name: "Get-faqsForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
  data() {
    return {
      file: {},
      
      languages: [],
      question: {},
      answer: {},
    };
  },
  async created() {
    this.languages = await new LanguagesController().GetActivelanguages();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.languages.forEach((element) => {
        this.newItem[element.code] = {
          question: this.question[element.code],
          answer: this.answer[element.code],
        };
      });

      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
        this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
        this.$parent.$parent.firstTab();
      }
    },
  },
  watch: {
    newItem(old) {
      this.languages.forEach((element) => {
        let locale = old.translations.find((a) => a.locale == element.code);
        this.$set(this.question, element.code, locale.question);
        this.$set(this.answer, element.code, locale.answer);

        // this.answer[element.code] = locale.answer;
      });
    },
  },
};
</script>

